import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  container: {
    margin: "0",
    minHeight: "100vh",
  },
  leftCol: {
    padding: 0,
    backgroundColor: "white",
  },
  rightCol: {
    backgroundColor: "#FBF8F3",
    padding: 0,
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  rightContent: {
    height: "100%",
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  linePattern1Parent: {
    position: "absolute",
    top: -320,
    right: 2,
    zIndex: 1,
    "& svg": {
      color: "#FFAF4A",
    },
  },
  linePattern2Parent: {
    position: "absolute",
    bottom: -325,
    left: 0,
    zIndex: 1,
    "& svg": {
      color: "#FFF",
    },
  },
  dashboardImg: {
    width: "85%",
    height: "75%",
    objectFit: "fill",
    zIndex: 10,
  },
  leftContent: {
    padding: "20px 32px 96px 32px",
    height: "100%",
    width: "100%",
    "@media (max-width: 420px)": {
      padding: "20px 20px 96px 20px",
    },
  },
  hdng: {
    color: "#262626",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 24,
  },
  subHdng: {
    color: "#737373",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: 16,
  },
  optionsAndHdngWrapper: {
    flex: 1,
    width: "100%",
    maxWidth: 360,
  },
  signoutLinkText: {
    "& .signoutLink": {
      textDecoration: "none",
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#FFAF4A",
    },
  },
  facilityOption: {
    width: 300,
    height: 60,
    padding: "6px 10px",
    border: "0.5px solid #FFAF4A",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    "& .facilityName": {
      marginLeft: 14,
      fontSize: 14,
      fontWeight: 600,
      fontFamily: "Inter",
      color: "#262626",
    },
    '& .avatar':{
      borderRadius: 15,
      '& .mantine-Avatar-placeholder':{
        borderRadius: 15
      }
    },
    "&:hover": {
      backgroundColor: "#ffae4a87",
      borderColor: "#262626",
    },
  },
}));

export default useStyles;
